// extracted by mini-css-extract-plugin
export default {"segmentNumbersCheckPanel":"to3ITuj2sYGeNzeeLUaB"};